import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactLoading from 'react-loading';
import { Box, Select, MenuItem, Tooltip, Grid, Button, Stack, Typography, useTheme } from "@mui/material";

import { CreateAssets, CreateVoiceClone, GetRegistration, RedubVoiceClone, UpdateVoiceClone, UploadThumbnail, UploadVideo } from '../../../../axios/ApiProvider';

import './voiceclones.scss';
import PanoramaFishEyeOutlinedIcon from '@mui/icons-material/PanoramaFishEyeOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import WindowOutlinedIcon from '@mui/icons-material/WindowOutlined';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import AddIcon from '@mui/icons-material/Add';
import PublishIcon from '@mui/icons-material/Publish';
import ClearIcon from '@mui/icons-material/Clear';

import GridItem from "./GridItem"
import ListItem from "./ListItem"
import { getVoiceClones } from '../../../../axios/ApiProvider';
import { copyObject } from "../../dashboard.config";
import emtpyThumb from '../../../../assets/image/emptyThumb.jpg'
import NodataImage from "../../../../assets/image/no data.png"
import { Modal } from "@mui/material";
import Swal from 'sweetalert2';

const BASE_BACKEND_URL = process.env.REACT_APP_BASE_BACKEND_URL;
const BASE_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_URL;

// Prev language setup
// const allLanguages = {
//   "en": { "name": "English", "model": "en_default", "initials": "en", "source": true, "target": true },
//   "es": { "name": "Spanish", "model": "es_default", "initials": "es", "source": true, "target": true  },
//   "fr": { "name": "French", "model": "fr_default", "initials": "fr", "source": true, "target": true  },
//   "de": { "name": "German", "model": "de_default", "initials": "de", "source": true, "target": false  },
//   "it": { "name": "Italian", "model": "it_default", "initials": "it", "source": true, "target": false  },
//   "pt": { "name": "Portuguese", "model": "pt_default", "initials": "pt", "source": true, "target": false  },
//   "pl": { "name": "Polish", "model": "pl_default", "initials": "pl", "source": false, "target": false  },
//   "tr": { "name": "Turkish", "model": "tr_default", "initials": "tr", "source": true, "target": false  },
//   "ru": { "name": "Russian", "model": "ru_default", "initials": "ru", "source": true, "target": false  },
//   "nl": { "name": "Dutch", "model": "nl_default", "initials": "nl", "source": false, "target": false  },
//   "cs": { "name": "Czech", "model": "cs_default", "initials": "cs", "source": false, "target": false  },
//   "ar": { "name": "Arabic", "model": "ar_default", "initials": "ar", "source": false, "target": false  },
//   "zh": { "name": "Chinese", "model": "zh_default", "initials": "zh", "source": true, "target": true  },
//   "hu": { "name": "Hungarian", "model": "hu_default", "initials": "hu", "source": false, "target": false  },
//   "kr": { "name": "Korean", "model": "kr_default", "initials": "kr", "source": true, "target": true  }, 
//   "jp": { "name": "Japanese", "model": "jp_default", "initials": "jp", "source": true, "target": true  },
//   "hi": { "name": "Hindi", "model": "hi_default", "initials": "hi", "source": false, "target": false  },
// };

//Last supported languages setup
const allLanguages = {
  "en": { "name": "English", "model": "en_default", "initials": "en", "source": true, "target": true },
  "es": { "name": "Spanish", "model": "es_default", "initials": "es", "source": true, "target": true  },
  "fr": { "name": "French", "model": "fr_default", "initials": "fr", "source": true, "target": true  },
  "de": { "name": "German", "model": "de_default", "initials": "de", "source": true, "target": true  },
  "it": { "name": "Italian", "model": "it_default", "initials": "it", "source": true, "target": true  },
  "pt": { "name": "Portuguese", "model": "pt_default", "initials": "pt", "source": true, "target": true  },
  "pl": { "name": "Polish", "model": "pl_default", "initials": "pl", "source": false, "target": true  },
  "tr": { "name": "Turkish", "model": "tr_default", "initials": "tr", "source": true, "target": true  },
  "ru": { "name": "Russian", "model": "ru_default", "initials": "ru", "source": true, "target": true  },
  "nl": { "name": "Dutch", "model": "nl_default", "initials": "nl", "source": false, "target": true  },
  "cs": { "name": "Czech", "model": "cs_default", "initials": "cs", "source": false, "target": true  },
  "ar": { "name": "Arabic", "model": "ar_default", "initials": "ar", "source": true, "target": true  },
  "zh-cn": { "name": "Chinese", "model": "zh-cn_default", "initials": "zh-cn", "source": true, "target": true  },
  "hu": { "name": "Hungarian", "model": "hu_default", "initials": "hu", "source": false, "target": true  },
  "ko": { "name": "Korean", "model": "ko_default", "initials": "ko", "source": true, "target": true  },
  "ja": { "name": "Japanese", "model": "ja_default", "initials": "ja", "source": true, "target": true  },
  "hi": { "name": "Hindi", "model": "hi_default", "initials": "hi", "source": false, "target": true  }
};

const sourceLanguageNames = Object.values(allLanguages)
  .filter(lang => lang.source)
  .map(lang => lang.name);

const targetLanguageNames = Object.values(allLanguages)
  .filter(lang => lang.target)
  .map(lang => lang.name);

function allLangLookup(lang, format) {
  const entry = Object.values(allLanguages).find((item) => item.name === lang);

  if (!entry) return null; // Return null if the language is not found

  switch (format) {
    case "initials":
      return entry.initials;
    case "model":
      return entry.model;
    case "name":
      return entry.name;
    default:
      return null; // Return null if the format is invalid
  }
}

const UploadFileModal = ({ open, onClose, onSubmit, redubUuid, sourceLang, redubPrevTargetLang, modalGetVoiceClones }) => {
  const theme = useTheme();
  const languageStrs = useSelector((store) => store.editdata.languageStrs);
  const [selectedLang, setSelectedLang] = useState("Turkish");
  const [selectedTargetLang, setSelectedTargetLang] = useState("Korean");

  useEffect(() => {
    if(sourceLang && redubPrevTargetLang) {
      setSelectedLang("");
    } else {
      setSelectedLang("Turkish");
      setSelectedTargetLang("Korean");
    }
  }, [sourceLang])

  const handleSubmit = () => {
    if (selectedLang && selectedTargetLang && selectedLang !== selectedTargetLang) {
      onSubmit(selectedLang, selectedTargetLang);
      onClose();
    }
    return selectedLang, selectedTargetLang;
  };
  
  const handleRedub = async () => {
    try {
      console.log("Calling RedubVoiceClone API");
      let redubResult = await RedubVoiceClone(redubUuid, selectedTargetLang, allLangLookup(selectedTargetLang, "model"));
      if (redubResult.state === 'success') {
        console.log("Redub result:", redubResult);
        const uuid = redubResult.data.uuid;
        console.log("Generated UUID for voice clone:", uuid);
        let config = {
          title: redubResult.data.asset_filename,
          lang: sourceLang,
          lang_initials: allLangLookup(sourceLang, "initials"),
          target_lang: selectedTargetLang,
          target_lang_model: allLangLookup(selectedTargetLang, "model"),
          target_language_name: selectedTargetLang,
        };
        console.log("Updating voice clone with config:", config);
        let updateResult = await UpdateVoiceClone(uuid, "QUEUED", config);
        console.log("Update Result :", updateResult);
  
        if (updateResult.state === 'success') {
          console.log("Refreshing voice clone list...");
          modalGetVoiceClones(1, false);
        }
        else {
        console.error("Error during voice clone creation:", redubResult.data.message);
      }
    } }
    catch (error) {
      console.error("Error during upload:", error);
    } 
};

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h3" mb={2} textAlign={"center"}>
         {sourceLang ? languageStrs.redub_another_language : languageStrs.upload_new_file}
        </Typography>
        <Stack spacing={3}>
          <div>
            <Typography variant="subtitle1" mb={1}>
            {sourceLang ? languageStrs.source_language : languageStrs.select_source_language}
            </Typography>
            {sourceLang ? (
               <Select
               default={sourceLang}
               value={sourceLang}
               onChange={(e) => setSelectedLang(e.target.value)}
               fullWidth
               disabled={true}
               sx={{
                 '& .MuiSelect-select': {
                   paddingTop: 3.3,
                   paddingBottom: 2,
                 },
                 '& .MuiSelect-icon': {
                   top: '60%',
                   transform: 'translateY(-60%)',
                 },
               }}
             > 
                 <MenuItem key={sourceLang} value={sourceLang}>
                 {languageStrs[sourceLang.toLowerCase()]}
                 </MenuItem>
             </Select>)
            :
            (
              <Select
              default="Turkish"
              value={selectedLang}
              onChange={(e) => setSelectedLang(e.target.value)}
              fullWidth
              sx={{
                '& .MuiSelect-select': {
                  paddingTop: 3.3,
                  paddingBottom: 2,
                },
                '& .MuiSelect-icon': {
                  top: '60%',
                  transform: 'translateY(-60%)',
                },
              }}
            >
              {sourceLanguageNames.map((lang) => (
                <MenuItem key={lang} value={lang}>
                  {languageStrs[lang.toLowerCase()]}
                </MenuItem>
              ))}
            </Select>
            ) 
            }
          </div>
          <div>
            <Typography variant="subtitle1" mb={1}>
              {languageStrs.select_target_language}
            </Typography>
            <Select
              default="Korean"
              value={selectedTargetLang}
              onChange={(e) => setSelectedTargetLang(e.target.value)}
              fullWidth
              sx={{
                '& .MuiSelect-select': {
                  paddingTop: 3.3,
                  paddingBottom: 2,
                },
                '& .MuiSelect-icon': {
                  top: '60%',
                  transform: 'translateY(-60%)',
                },
              }}
            >
              {targetLanguageNames.map((targetLang) => (
                <MenuItem key={targetLang} value={targetLang}>
                  {languageStrs[targetLang.toLowerCase()]}
                </MenuItem>
              ))}
            </Select>
          </div>
          {selectedLang === selectedTargetLang ? 
          <Typography color="#EE4B2B">{languageStrs.select_different_source_and_target_languages}!</Typography> :
          selectedTargetLang === redubPrevTargetLang ? 
          <Typography color="#EE4B2B">{languageStrs.select_different_target_language}!</Typography> :
          sourceLang === selectedTargetLang ? 
          <Typography color="#EE4B2B">{languageStrs.select_different_source_and_target_languages}!</Typography>
          : null
          }
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="outlined" onClick={onClose} startIcon={<ClearIcon />}>
              {languageStrs.cancel}
            </Button>
            <Button
            variant="outlined"
            startIcon={<PublishIcon />}
            style={theme.palette.mode === "dark" ? {backgroundColor: "#141b2d"} : {backgroundColor: "transparent"}}
            onClick={sourceLang && redubUuid ? handleRedub : handleSubmit}
            //disabled={selectedLang === selectedTargetLang || sourceLang === selectedTargetLang || redubPrevTargetLang === selectedTargetLang}
            >
              {languageStrs.submit}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};


export const VoiceClones = () => {

  const [toolbarStyle, SetToolbarStyle] = useState('list');
  const ToolbarStyleChange = () => { SetToolbarStyle(toolbarStyle === 'grid' ? 'list' : 'grid'); }

  const [projectsArr, setProjectsArr] = useState([]);
  const [sortedArr, setSortedArr] = useState([]);
  const [sortKey, setSortKey] = useState(1);

  //const [reloadUrl, setReloadUrl] = useState(BASE_BACKEND_URL + '/user/voiceclones/')
  
  const [isModalOpen, setModalOpen] = useState(false);
  const [uploadProgressMap, setUploadProgressMap] = useState({});
  const [isUploading, setIsUploading] = useState(false)
  const [isLoading, setIsLoading] = useState(true);
  
  const languageStrs = useSelector((store) => store.editdata.languageStrs);
  const [selectedLang, setSelectedLang] = useState("Turkish");
  const [selectedTargetLang, setSelectedTargetLang] = useState("Korean");

  //Redub related
  const [sourceLang, setSourceLang] = useState(null);
  const [redubUuid, setRedubUuid] = useState(null);
  const [redubFilename, setRedubFilename] = useState(null);
  const [redubPrevTargetLang, setRedubPrevTargetLang] = useState(null);
  
  const [currentResponsePageIndex, setCurrentResponsePageIndex] = useState(1);
  const [currentLocalPageIndex, setCurrentLocalPageIndex] = useState(1)
  const [totalPages, setTotalPages] = useState(1);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [prevPageUrl, setPrevPageUrl] = useState(null);

  const loginState = useSelector((store) => store.maindata.loginState);  
  
  const theme = useTheme();

  useEffect(() => {
    GetVoiceClones(currentResponsePageIndex, true);
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      GetVoiceClones(currentLocalPageIndex, false);
    }, 3000);
  
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [currentLocalPageIndex]);
  

  useEffect(() => {
    let tempArr = copyObject(projectsArr)

    tempArr.sort((a, b) => {
      let returnValue;
      if (sortKey === 1) returnValue = a.title - b.title
      else if (sortKey === 2) returnValue = (+ new Date(a.updated_at)) - (+ new Date(b.updated_at))
      else if (sortKey === 3) returnValue = (+ new Date(b.updated_at)) - (+ new Date(a.updated_at))
      return returnValue
    })

    //Check if any video is uploading
    const isUploading = tempArr.some(videoItem => videoItem.state === 1);
    setIsUploading(isUploading);

      // Inject progress values from state
    tempArr = tempArr.map((item) => ({
      ...item,
      progress: uploadProgressMap[item.uuid] || item.progress || 0,
    }));
    setSortedArr(tempArr)
  }, [projectsArr, sortKey, uploadProgressMap])

  const getThumbnailsInfo = (duration) => {
    let tempThumbnails = [];
    let length = 1;
    switch (true) {
      case duration > 100: length = 10; break;
      case duration > 3: length = 5; break;
      default: length = 1; break;
    }
  
    for (let i = 0; i < length; i++) {
      const timestamp = duration / length * i + 0.1;
  
      tempThumbnails.push({ time: timestamp, content_type: "blob" });
    }
    return tempThumbnails
  }

  const handleProgressUpdate = (uuid, progress) => {
    setProjectsArr((prevProjects) =>
      prevProjects.map((item) =>
        item.uuid === uuid ? { ...item, progress } : item
      )
    );
  };

  const audioWaves = `
  <svg id="wave" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 38.05" width="320" height="180" style="background-color: black;">
  <rect width="100%" height="100%" fill="black" />
  <path id="Line_1" fill="#fff" data-name="Line 1" d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z"/>
  <path id="Line_2" fill="#fff" data-name="Line 2" d="M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z"/>
  <path id="Line_3" fill="#fff" data-name="Line 3" d="M12.91,0L12.78,0A1,1,0,0,0,12,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z"/>
  <path id="Line_4" fill="#fff" data-name="Line 4" d="M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z"/>
  <path id="Line_5" fill="#fff" data-name="Line 5" d="M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z"/>
  <path id="Line_6" fill="#fff" data-name="Line 6" d="M30.91,10l-0.12,0A1,1,0,0,0,30,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H30.91Z"/>
  <path id="Line_7" fill="#fff" data-name="Line 7" d="M36.91,0L36.78,0A1,1,0,0,0,36,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H36.91Z"/>
  <path id="Line_8" fill="#fff" data-name="Line 8" d="M42.91,9L42.78,9A1,1,0,0,0,42,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H42.91Z"/>
  <path id="Line_9" fill="#fff" data-name="Line 9" d="M48.91,15l-0.12,0A1,1,0,0,0,48,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H48.91Z"/>
  </svg>
  `
 const AudioWaves = () => {
  return(
    <svg id="wave" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 38.05">
      <path id="Line_1" data-name="Line 1" d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z"/>
      <path id="Line_2" data-name="Line 2" d="M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z"/>
      <path id="Line_3" data-name="Line 3" d="M12.91,0L12.78,0A1,1,0,0,0,12,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z"/>
      <path id="Line_4" data-name="Line 4" d="M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z"/>
      <path id="Line_5" data-name="Line 5" d="M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z"/>
      <path id="Line_6" data-name="Line 6" d="M30.91,10l-0.12,0A1,1,0,0,0,30,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H30.91Z"/>
      <path id="Line_7" data-name="Line 7" d="M36.91,0L36.78,0A1,1,0,0,0,36,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H36.91Z"/>
      <path id="Line_8" data-name="Line 8" d="M42.91,9L42.78,9A1,1,0,0,0,42,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H42.91Z"/>
      <path id="Line_9" data-name="Line 9" d="M48.91,15l-0.12,0A1,1,0,0,0,48,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H48.91Z"/>
  </svg>
  )
 }

  const blob_Upload = async (filename, blobURL, mimeType, uploading, flag) => {
    let userCredits = {subtitle_state: null, subtitle_remaining: 0};
    let userCredentials = await GetRegistration();
    userCredits.subtitle_state = userCredentials.data.subtitle_state;
    userCredits.subtitle_remaining = userCredentials.data.subtitle_remaining;

    const getMediaDuration = async (blob) => {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob);
        const mimeType = blob.type;
    
        let media;
        if (mimeType.startsWith("audio")) {
          media = new Audio();
        } else if (mimeType.startsWith("video")) {
          media = document.createElement("video");
        } else {
          reject("Unsupported file type");
          return;
        }
    
        media.src = url;
        media.onloadedmetadata = () => {
          URL.revokeObjectURL(url);
          resolve(media.duration / 60); // Convert seconds to minutes
        };
    
        media.onerror = () => {
          reject("Error loading media file");
        };
      });
    };    
    try {
      // Fetch the blob data and create a file object
      let blob = await fetch(blobURL).then((r) => r.blob());
      let durationInMinutes = await getMediaDuration(blob);
      durationInMinutes = parseFloat(durationInMinutes.toFixed(2)); 

      if (userCredits.subtitle_state === false || userCredits.subtitle_remaining < durationInMinutes) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "You need more credits to proceed!",
          showConfirmButton: true,
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = `${BASE_FRONTEND_URL}/pricing`;
          }
        });
        return;
      }

      let file = new File([blob], filename, { type: mimeType, lastModified: new Date().getTime() });
          const dataURLToBlob = (dataURL) => {
            const [header, base64Data] = dataURL.split(',');
            const mime = header.match(/:(.*?);/)[1];
            const binary = atob(base64Data);
            const array = [];
          
            for (let i = 0; i < binary.length; i++) {
              array.push(binary.charCodeAt(i));
            }
          
            return new Blob([new Uint8Array(array)], { type: mime });
          };
          
         // Generate thumbnail
         const generateThumbnail = () => {
          return new Promise((resolve, reject) => {
            const video = document.createElement("video");
            video.src = blobURL;
            video.muted = true;
            video.style.display = "none";
            document.body.appendChild(video);
        
            video.addEventListener("loadeddata", () => {
              video.currentTime = 2; // Seek to 2 seconds
            });
        
            video.addEventListener("seeked", () => {
              const canvas = document.createElement("canvas");
              const targetWidth = 320;
              const targetHeight = 180;
        
              canvas.width = targetWidth;
              canvas.height = targetHeight;
        
              const ctx = canvas.getContext("2d");
        
              // Clear canvas and set black background (for blank spaces)
              ctx.fillStyle = "black";
              ctx.fillRect(0, 0, targetWidth, targetHeight);
        
              // Video dimensions
              const videoWidth = video.videoWidth;
              const videoHeight = video.videoHeight;
              const videoAspectRatio = videoWidth / videoHeight;
              const canvasAspectRatio = targetWidth / targetHeight;
        
              let renderWidth, renderHeight;
              let offsetX = 0, offsetY = 0;
        
              if (videoAspectRatio > canvasAspectRatio) {
                // Video is wider than canvas, fit width and letterbox vertically
                renderWidth = targetWidth;
                renderHeight = targetWidth / videoAspectRatio;
                offsetY = (targetHeight - renderHeight) / 2;
              } else {
                // Video is taller or equal aspect ratio, fit height and letterbox horizontally
                renderHeight = targetHeight;
                renderWidth = targetHeight * videoAspectRatio;
                offsetX = (targetWidth - renderWidth) / 2;
              }
        
              // Draw the video frame centered with possible letterboxing
              ctx.drawImage(video, offsetX, offsetY, renderWidth, renderHeight);
        
              const thumbnailDataUrl = canvas.toDataURL("image/png");
        
              // Cleanup
              video.remove();
              canvas.remove();
        
              resolve(thumbnailDataUrl);
            });
        
            video.addEventListener("error", (err) => {
              reject(err);
            });
          });
        };
        
        let thumbnail;

        //Check if the file is audio or video
        const isAudioFile = (mimeType) => {
          return mimeType.startsWith("audio/");
        };
        if (isAudioFile(mimeType)) {
          thumbnail = "data:image/svg+xml;base64," + btoa(audioWaves);
        } else {
          thumbnail = await generateThumbnail()
          .then((thumbnailDataUrl) => dataURLToBlob(thumbnailDataUrl))
          .catch((err) => console.error("Error generating thumbnail:", err));
        }

      console.log("Calling CreateVoiceClone API");
      const voiceCloneCreateResult = await CreateVoiceClone(filename, selectedTargetLang);
  

      if (voiceCloneCreateResult.state === 'success') {
        console.log("CreateVoiceClone result:", voiceCloneCreateResult);
    
        // Extract uuid for the current upload from the API response
        const uuid = voiceCloneCreateResult.data.uuid;
        console.log("Generated UUID for voice clone:", uuid);
  
        // Prepare configuration object for the update request
        let config = {
          title: filename,
          lang: selectedLang,
          lang_initials: allLangLookup(selectedLang, "initials"),
          target_lang: selectedTargetLang,
          target_lang_initials: allLangLookup(selectedTargetLang, "initials"),
          target_lang_model: allLangLookup(selectedTargetLang, "model"),
          target_language_name: allLangLookup(selectedTargetLang, "name"),
        };
  
        console.log("Updating voice clone with config:", config);
  
        // Update voice clone state to "UPLOADING"
        let updateResult = await UpdateVoiceClone(uuid, "UPLOADING", config);
        console.log("updateResult :", updateResult);
  
        if (updateResult.state === 'success') {
          // Refresh the voice clones list after upload is complete
          console.log("Refreshing voice clone list...");
          GetVoiceClones(currentLocalPageIndex, false);
  
         // Properly handle progress by triggering the provided function
         const handleProgress = (percentCompleted) => {
          if (percentCompleted >= 0 && percentCompleted < 100) {
            uploading(uuid, percentCompleted);
            localStorage.setItem(`${uuid}-upload-progress`, percentCompleted);

          } else if (percentCompleted === 100){
            setInterval(() => localStorage.removeItem(`${uuid}-upload-progress`), 3000);
          }
        };
        
          let uploadThumbnailResult = await UploadThumbnail(voiceCloneCreateResult.data.assetthumbnail_upload_signed_url, thumbnail);
          let uploadResult = await UploadVideo(file, voiceCloneCreateResult.data.upload_url, handleProgress);
  
          if (uploadResult.state === 'success'  && uploadThumbnailResult.state === 'success') {
            console.log("Upload finished successfully.");
  
            let uploadSuccessResult = await UpdateVoiceClone(uuid, "UPLOAD_SUCCESS", config);
            console.log("updateResult :", updateResult);
  
            if (uploadSuccessResult.state === 'success') {
              // Refresh the voice clones list after upload success
              console.log("Refreshing voice clone list...");
              GetVoiceClones(currentLocalPageIndex, false);
  
              console.log("config before UpdateVoiceClone QUEUED:", config);
  
              // Update voice clone state to "QUEUED"
              let updateQueuedResult = await UpdateVoiceClone(uuid, "QUEUED", config);
              console.log("updateResult :", updateResult);
  
              if (updateQueuedResult.state === 'success') {
                console.log("Refreshing voice clone list...");
                GetVoiceClones(currentLocalPageIndex, false);
              } else {
                console.error("Queued update failed with message:", updateQueuedResult.data.message);
              }
            }
          } else {
            console.error("Upload failed with message:", uploadResult.data.message);
          }
        } else {
          console.error("Upload state update failed with message:", updateResult.data.message);
        }
      } else {
        console.error("Error during voice clone creation:", voiceCloneCreateResult.data.message);
      }
    } catch (error) {
      console.error("Error during upload:", error);
    } 
  };
  
  
  const GetVoiceClones = async (pageIndex, rotatingDisk) => {
    setCurrentLocalPageIndex(pageIndex);
    if (rotatingDisk == true) setIsLoading(false);
    let result = await getVoiceClones((BASE_BACKEND_URL + '/user/voiceclones/'), pageIndex);
    if (result.state === 'success') {
      const newProjectsArr = result.data.results;
      setTotalPages(result.data.total_pages);
      setCurrentResponsePageIndex(result.data.current_page);
      if (JSON.stringify(newProjectsArr) !== JSON.stringify(projectsArr)) {
        setProjectsArr(newProjectsArr);
        setNextPageUrl(result.data.next);
        setPrevPageUrl(result.data.previous);
      }
    }
    if (rotatingDisk == true) setIsLoading(true);
    // Update progress map with the latest progress values
    setUploadProgressMap((prevProgressMap) => {
      const newProgressMap = { ...prevProgressMap };
      if (result.data.results) {
        result.data.results.forEach((item) => {
          if (item.progress !== undefined) {
            newProgressMap[item.uuid] = item.progress;
          }
        });
     }
      return newProgressMap;
    });
  }

  const nextPage = () => { 
   if(currentResponsePageIndex < totalPages) {
    setNextPageUrl(null);
    setPrevPageUrl(null);
    setCurrentLocalPageIndex(currentResponsePageIndex);
    GetVoiceClones(currentLocalPageIndex + 1, true);
   }
  }
  const prePage = () => { 
    if(currentResponsePageIndex > 0) {
      setNextPageUrl(null);
      setPrevPageUrl(null);
      setCurrentLocalPageIndex(currentResponsePageIndex);
      GetVoiceClones(currentLocalPageIndex - 1, true);
    }
  }

  const firstPage = () => {
    if (currentLocalPageIndex !== 1) {
      setNextPageUrl(null);
      setPrevPageUrl(null);
      GetVoiceClones(1, true);
      setCurrentLocalPageIndex(1);
    }
  }
  const lastPage = () => {
    if (currentLocalPageIndex !== totalPages) {
      setNextPageUrl(null);
      setPrevPageUrl(null);
      GetVoiceClones(totalPages, true);
      setCurrentLocalPageIndex(totalPages);
    }
  }

  const onHandleDelete = () => {
    GetVoiceClones(true);
  }

  const handleCreateNewAIDubbing = async () => {
    try {
      let resultLanguageModal = await showModal(); // Wait for the modal to resolve
      if (resultLanguageModal) {
        console.log("handleCreateNewAIDubbing resultLanguageModal ");
        document.getElementById("fileInput").click(); // Trigger file input click
      } else {
        console.log("Modal was closed without submission.");
      }
    } catch (error) {
      console.error("Error handling modal:", error);
    }
    console.log("After modal");
  };

  const handleClose = (result) => {
    setModalOpen(false);
    
  };

  const showModal = (itemData) => {
    if(!loginState) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "You need to log in to use this feature!",
        showConfirmButton: true,
        confirmButtonText: "Go to Login Page",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href=`${BASE_FRONTEND_URL}/signin`;
          // window.location.reload();
        }
      });
    } else {
      if(itemData) {
        setSourceLang(itemData.lang);
        setRedubUuid(itemData.uuid);
        setRedubFilename(itemData.title);
        setRedubPrevTargetLang(itemData.target_lang)
      } else {
        setSourceLang(null);
        setRedubUuid(null);
      }
      return new Promise((resolve) => {
        setModalOpen(true);
        return ;
      });
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const mimeType = file.type || "video/mp4" || "audio/mp3";

    await blob_Upload(file.name, URL.createObjectURL(file), mimeType, handleProgressUpdate, true);

  };

  const handleModalSubmit = (lang, targetLang) => {
    setSelectedLang(lang);
    setSelectedTargetLang(targetLang);
    setModalOpen(false);
    document.getElementById("fileInput").click();
    return;
  };

  const handleModalClose = () => {
    setModalOpen(false);
    document.getElementById("fileInput").value = "";  
  };

  const audioWavesStyles = {
    dark: {fill: "#ffffff"},
    light: {fill: "#000000"},  
  }



  return (
    <Box className="custom-projects-wrapper">
        <Box className="custom-projects-toolbar-section"
        sx={{borderColor: theme.palette.mode === 'dark' 
        ? theme.palette.grey[800] + "!important" 
        : theme.palette.grey[200] + "!important",}}
        >
        <Box className="toolbar-Breadcrumbs-contain">
          <Link to={`#`}>{languageStrs.voice_clones}</Link>
        </Box>

        <Box className="toolbar-layoutOption-section">
          {/* <Box className="sortby-wrapper">
            <span className="sortby-title">Sort By</span>

            <Select value={sortKey}
              className="toolbar-SortBy-select"
              onChange={(event) => { setSortKey(event.target.value); }}
            >
              <Box className="toolbar-SortBy-select-header">Sort By</Box>

              <MenuItem value={1} className="toolbar-SortBy-select-item">
                <PanoramaFishEyeOutlinedIcon className="radio-outline" />
                <RadioButtonCheckedOutlinedIcon className="radio-checked" />
                <span>Name</span>
              </MenuItem>

              <MenuItem value={2} className="toolbar-SortBy-select-item">
                <PanoramaFishEyeOutlinedIcon className="radio-outline" />
                <RadioButtonCheckedOutlinedIcon className="radio-checked" />
                <span>Date Created</span>
              </MenuItem>

              <MenuItem value={3} className="toolbar-SortBy-select-item">
                <PanoramaFishEyeOutlinedIcon className="radio-outline" />
                <RadioButtonCheckedOutlinedIcon className="radio-checked" />
                <span>Date Modified</span>
              </MenuItem>
            </Select>
          </Box> */}

          {/* <Box className="projects-toolbar-style-contain" onClick={ToolbarStyleChange}>
            {toolbarStyle === 'grid' ? (
              <Tooltip title="view as list"><FormatListBulletedOutlinedIcon /></Tooltip>
            ) : (
              <Tooltip title="view as grid"><WindowOutlinedIcon /></Tooltip>
            )}
          </Box> */}
        </Box>
      </Box>

      <Box>
        <Button
          className="upload-file-btn"
          variant="outlined"
          onClick={handleCreateNewAIDubbing}
          startIcon={<AddIcon />}
          style={theme.palette.mode === "dark" ? {backgroundColor: "#141b2d"} : {backgroundColor: "transparent"}}
        >
        <Typography variant="subtitle">{languageStrs.upload_new_file}</Typography>
        </Button>
        <input
          id="fileInput"
          type="file"
          accept="video/*, audio/*"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
    </Box>

          

      <Box className='projects-next-preview-btn'>
        <Stack direction="row" spacing={2} alignItems={"center"}>

          <Button onClick={firstPage} variant="outlined" startIcon={<SkipPreviousIcon />} disabled={currentLocalPageIndex === 1 ? true : false}>
          {languageStrs.first}
          </Button>
          <Button onClick={prePage} variant="outlined" disabled={!!prevPageUrl ? false : true}>
          <KeyboardDoubleArrowLeftIcon />
          </Button>
          <Typography variant="h4">{totalPages && currentResponsePageIndex + " / " + totalPages}</Typography>
          <Button onClick={nextPage} variant="outlined" disabled={!!nextPageUrl ? false : true}>
          <KeyboardDoubleArrowRightIcon />
          </Button>
          <Button onClick={lastPage} variant="outlined" endIcon={<SkipNextIcon />} disabled={currentLocalPageIndex === totalPages ? true : false}>
          {languageStrs.last}
          </Button>
        </Stack>
      </Box>

      <Box className="custom-projects-contents-section">
      {isLoading && sortedArr.length === 0 && 
      <Box className="no-data-container">
          <div className="audio-waves" style={theme.palette.mode === "dark" ? audioWavesStyles.dark : audioWavesStyles.light}>
           <AudioWaves />
           <AudioWaves />
           <AudioWaves />
          </div>
            {/* <h1 className="text-center text-[30px]">{languageStrs.you_dont_have_content_here}</h1> */}
            <h1 className="text-center text-[30px] no-voice-warning">{languageStrs.no_voice_clones}</h1>
            <Typography  variant="h4" textAlign={"center"} mt={2} className="no-voice-desc">{languageStrs.upload_file_to_create_first_voice_clone}!</Typography>
            <Box width={"max-content"} mx={"auto"} mt={2}>
            <Button
              className="upload-file-btn"
              variant="outlined"
              onClick={handleCreateNewAIDubbing}
              startIcon={<AddIcon />}
              style={theme.palette.mode === "dark" ? {backgroundColor: "#141b2d"} : {backgroundColor: "transparent"}}
            >
            <Typography variant="subtitle">{languageStrs.upload_new_file}</Typography>
            </Button>
            <input
              id="fileInput"
              type="file"
              accept="video/*, audio/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            </Box>

      </Box>
      } 
      {sortedArr.length !== 0 &&
        <>
          {toolbarStyle === 'grid' ? (
            <Box className="projects-container">
              <Grid container spacing={2}>
                {sortedArr.map((item, index) => (
                  <Grid item xs={12} sm={6} md={6} lg={4} xl={2.4} key={index}>
                    <GridItem itemData={item} onDelete={onHandleDelete} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : (
            <Box className="list-projects-container">
              <Box className="projects-header-wrapper"
               sx={{borderColor: theme.palette.mode === 'dark' 
                ? theme.palette.grey[800] + "!important" 
                : theme.palette.grey[200] + "!important",}}
              >
                <Box className="projects-header-NameTableCell1">{languageStrs.name}</Box>
                {/* <Box className="projects-header-NameTableCell1">{languageStrs.language}</Box> */}
                {/* <<Box className="projects-header-NameTableCell2">{languageStrs.status}</Box> */}
                <Box className="projects-header-NameTableCell3 date-modified-heading">{languageStrs.data_modified}</Box>
                <Box className="projects-header-NameTableCell4"></Box>
              </Box>

              {sortedArr.map((item, index) => (
                <ListItem
                itemData={item}
                key={item.uuid}
                onDelete={onHandleDelete}
                isUploading={isUploading}
                showModal={showModal}
                currentLocalPageIndex={currentLocalPageIndex}
                getVoiceClones={GetVoiceClones}
                />
              ))}
            </Box>
          )}
        </>
      }
      </Box>

      {!isLoading && (
        <Box className='absolute top-1/2 left-1/2 -translate-x-1/2'>
          <ReactLoading type={'spinningBubbles'} color='rgb(53 126 221)' height={100} width={100} />
        </Box>
      )}

      <UploadFileModal
        open={isModalOpen}
        onClose={handleModalClose}
        onSubmit={handleModalSubmit}
        redubUuid={redubUuid}
        sourceLang={sourceLang}
        redubFilename={redubFilename}
        redubPrevTargetLang={redubPrevTargetLang}
        currentLocalPageIndex={currentLocalPageIndex}
        modalGetVoiceClones={GetVoiceClones}
      />

    </Box >
  )
}